import { useMemo } from 'react';

import { useGetAccountQuery } from '@/features/auth';

export const useRemainingFreeTrialDays = () => {
  const { data: account } = useGetAccountQuery();

  const remainingTrialDays = useMemo(() => {
    if (!account?.companyCreatedAt) return 0;
    const created = new Date(account.companyCreatedAt);
    const now = new Date();
    const diffTime = now.getTime() - created.getTime();
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    const remaining = 14 - diffDays;
    return remaining > 0 ? remaining : 0;
  }, [account?.companyCreatedAt]);

  const isDemoCompany = !!account?.isDemoCompany;

  return { remainingTrialDays, isDemoCompany };
};
